<div class="row">
  <div class="col-md-12">
    <ng-container *ngIf="isApiOnProgress">
      <app-list-view-loader *ngFor="let item of [1,2]"></app-list-view-loader>
    </ng-container>
    <ng-container *ngIf="!isApiOnProgress && classWeeklyData && classWeeklyData?.length > 0">
      <div *ngFor="let classData of classWeeklyData; let i = index">
        <!-- {{setWeek(i + 1, classData)}} -->
        <p [ngClass]="{'wk-title p-0': true,  'mt-3': i == 0, 'mt-4': i > 0}" class="wk-title mt-3">
          <!-- Week {{ (classData.w - customFilter.week) + 1}} -->
          Week {{classData.w}}
          <br>
          <span>
            {{classData.s | date:'d MMM'}} - {{classData.e | date:'d MMM'}}
            <!-- - {{classData.sessions}} Sessions -->
          </span>
        </p>

        <app-class-list-card *ngFor="let data of classData.data" [dataType]="'course'" [classData]="data">
        </app-class-list-card>
      </div>
    </ng-container>
    <!-- <app-class-list-card *ngFor="let data of classData"  [dataType]="'course'" [classData]="data"></app-class-list-card>  -->
  </div>
</div>
<div class="d-flex justify-content-center mt-5" *ngIf="customFilter?.pages > 1">
  <pagination [totalItems]="customFilter?.total" [(ngModel)]="currentPage" [itemsPerPage]="customFilter?.filters?.limit"
    (pageChanged)="pageChanged($event)" previousText="&lsaquo;" nextText="&rsaquo;"></pagination>
</div>